/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MachineUserSettingDto,
    MachineUserSettingDtoFromJSON,
    MachineUserSettingDtoToJSON,
} from '../models';

export interface ApiMachineUserSettingsPostRequest {
    machineUserSettingDto?: MachineUserSettingDto;
}

export interface ApiMachineUserSettingsPutRequest {
    machineUserSettingDto?: MachineUserSettingDto;
}

/**
 * no description
 */
export class MachineUserSettingsApi extends runtime.BaseAPI {

    /**
     * Legt die Benachrichtigungseinstellungen an. MachineId und UserId stehen im Body. Existiert der Datensatz bereits, wird HTTP409 zurückgegeben.
     */
    async apiMachineUserSettingsPostRaw(requestParameters: ApiMachineUserSettingsPostRequest): Promise<runtime.ApiResponse<MachineUserSettingDto>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Machines/userSettings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachineUserSettingDtoToJSON(requestParameters.machineUserSettingDto),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineUserSettingDtoFromJSON(jsonValue));
    }

    /**
     * Legt die Benachrichtigungseinstellungen an. MachineId und UserId stehen im Body. Existiert der Datensatz bereits, wird HTTP409 zurückgegeben.
     */
    async apiMachineUserSettingsPost(requestParameters: ApiMachineUserSettingsPostRequest): Promise<MachineUserSettingDto> {
        const response = await this.apiMachineUserSettingsPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Aktualisiert die Benachrichtigungseinstellungen. MachineId und UserId stehen im Body. Existiert der Datensatz noch nicht, wird HTTP404 zurückgegeben.
     */
    async apiMachineUserSettingsPutRaw(requestParameters: ApiMachineUserSettingsPutRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Machines/userSettings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MachineUserSettingDtoToJSON(requestParameters.machineUserSettingDto),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Aktualisiert die Benachrichtigungseinstellungen. MachineId und UserId stehen im Body. Existiert der Datensatz noch nicht, wird HTTP404 zurückgegeben.
     */
    async apiMachineUserSettingsPut(requestParameters: ApiMachineUserSettingsPutRequest): Promise<void> {
        await this.apiMachineUserSettingsPutRaw(requestParameters);
    }

}